import type { EventDto, EventType } from '../../api/types';
import { buildEventLink } from '../../telegram/eventLink';
import { formatTimeRange, formatWeekdayDateShortRu } from '../../utils/time';

// Mirrors the notification titles in backend AddUserToEventNotification.
const EVENT_TYPE_TITLE: Record<EventType, string> = {
  boardgames: '🎲 Настольная игра',
  ping_pong: '🏓 Настольный теннис',
  fencing: '⚔️ Фехтование',
  archery: '🏹 Лук',
  hiking: '🌲 Походы на природу',
  courtyard: '🏡 Двор',
};

type ShareGame = { name: string; gameUrl?: string | null } | null | undefined;

/**
 * Text copied from the event card: a short description plus labelled links.
 * Participant counts are deliberately omitted — they would be stale right after pasting.
 */
export function buildEventShareText(event: EventDto, game?: ShareGame): string {
  const when = [formatTimeRange(event.startAt, event.endAt), formatWeekdayDateShortRu(event.startAt)]
    .filter(Boolean)
    .join(' · ');

  const lines = [
    `${EVENT_TYPE_TITLE[event.type] ?? EVENT_TYPE_TITLE.boardgames} «${event.title}»`,
    `📅 ${when}`,
    `👉 Открыть мероприятие: ${buildEventLink(event.id)}`,
  ];

  const gameName = game?.name ?? event.game?.name;
  if (gameName) {
    lines.push(`🎯 Игра: ${gameName}`);
    if (game?.gameUrl) lines.push(`📖 Об игре: ${game.gameUrl}`);
  }

  return lines.join('\n');
}
